module.exports = __webpack_public_path__ + "static/media/fast_rewind-24px.f803d444.svg";